(function(){
 'use strict';
 if(window.BuceBannerMetrics)return;
 const key='buce-banner-attribution-v1',ttl=24*60*60*1000,seen=new Set(),targets=new Map();
 let chain=Promise.resolve(),memory=null,privacyRequested=false;
 const status={version:'ME1',views:0,clicks:0,savings:0,targets:0,queued:0,publishErrors:0,cartWrite:'none',receiver:'not_verified'};
 const isQA=()=>window.Shopify?.designMode===true||window.Shopify?.theme?.role!=='main'||new URLSearchParams(location.search).has('preview_theme_id');
 status.mode=isQA()?'qa':'live';
 let rewardToken='',rewardCurrency='';const rewarded=new Map();
 function allowed(purpose){try{const p=window.Shopify?.customerPrivacy;return purpose==='marketing'?p?.marketingAllowed()===true:p?.analyticsProcessingAllowed()===true;}catch{return false;}}
 function read(){if(isQA()||!allowed('analytics')||!allowed('marketing'))return null;try{const r=JSON.parse(sessionStorage.getItem(key)||'null');return r&&Date.now()-r.started<ttl?r:null;}catch{return memory&&Date.now()-memory.started<ttl?memory:null;}}
 function save(r){if(isQA())return;memory=r;try{sessionStorage.setItem(key,JSON.stringify(r));}catch{}}
 function publish(name,props,local=true){
  if(isQA()||!allowed('analytics'))return false;
  if(local)window.BuceV2Events?.emit(name,props);
  try{if(typeof window.Shopify?.analytics?.publish==='function'){Promise.resolve(window.Shopify.analytics.publish('buce:'+name,props)).catch(()=>{status.publishErrors++;});status.queued++;return true;}}catch{status.publishErrors++;}
  return false;
 }
 function sync(r,clear=false){
  if(isQA())return;
  const attrs={'__buce_banner_first':clear?'':r.first,'__buce_banner_last':clear?'':r.last,'__buce_banner_first_at':clear?'':r.started.toString(),'__buce_banner_last_at':clear?'':r.clicked.toString(),'__buce_banner_version':clear?'':status.version};
  chain=chain.catch(()=>{}).then(async()=>{
   if(isQA())return;
   if(!clear&&(!allowed('analytics')||!allowed('marketing')))return;
   try{const root=window.Shopify?.routes?.root||'/';const response=await fetch(root+'cart/update.js',{method:'POST',credentials:'same-origin',keepalive:true,headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({attributes:attrs})});status.cartWrite=response.ok?(clear?'cleared':'saved'):'failed';}
   catch{status.cartWrite='failed';}
  });
 }
 const main={'scale':'ahorro-por-pares','buce_luxury_box':'caja-lujo','image_parent_BuceComboAugust':'look-august','image_parent_NxqRb9':'samba-ahorro','image_parent_Y3aGXE':'ofertas','image_parent_QkdhPL':'5plus1'};
 const groups={
  slideshow_mkxizC:{campaign:'principal',blocks:main},
  hero_image_rWMPp7:{campaign:'samba',blocks:{image_parent_SambaAhorro:'ahorro',image_parent_SambaEstilo:'estilo',image_parent_SambaCuotas:'cuotas'}},
  hero_image_KzzUYX:{campaign:'august',blocks:{image_parent_AugustCombo:'combo',image_parent_Augustvariedad:'variedad',image_parent_Augustlook:'look',image_parent_Augustcuotas:'cuotas'}},
  hero_image_PrNFAJ:{campaign:'nrw',blocks:{image_parent_NrwDetroit:'bordado-regalo',image_parent_NrwLA:'look-regalo',image_parent_NrwRelic:'halloween-regalo'}},
  hero_image_Tajcnz:{campaign:'mas-vendidos'},
  hero_image_6LgBgw:{campaign:'ofertas-seccion'},
  newsletter_CUexie:{campaign:'deportivos'},
  hero_image_mH8NAk:{campaign:'recien-llegados'}
 };
 function props(el){const d=el.dataset;return {banner_id:d.buceBannerId,campaign:d.buceBannerCampaign,angle:d.buceBannerAngle,position:Number(d.buceBannerPosition),creative_version:'CP36-UP1',theme_id:String(window.Shopify?.theme?.id||''),measurement_version:status.version,currency:window.Shopify?.currency?.active||''};}
 function active(el){
  const slider=el.closest('.t4s-flicky-slider');
  if(!slider)return true;
  const selected=slider.querySelector('.t4s-slide.is-selected');
  return selected?selected===el:slider.querySelector('.t4s-slide')===el;
 }
 function inspect(el){
  const entry=targets.get(el);if(!entry)return;clearTimeout(entry.timer);
  if(isQA()||entry.ratio<.5||!active(el)||document.visibilityState==='hidden'||!allowed('analytics')||seen.has(el.dataset.buceBannerId))return;
  entry.timer=setTimeout(()=>{
   if(entry.ratio>=.5&&active(el)&&document.visibilityState!=='hidden'&&publish('banner_view',props(el))){seen.add(el.dataset.buceBannerId);status.views++;}
  },1000);
 }
 const observer=window.IntersectionObserver?new IntersectionObserver(entries=>entries.forEach(entry=>{const r=targets.get(entry.target);if(r){r.ratio=entry.intersectionRatio;inspect(entry.target);}}),{threshold:[0,.5,1]}):null;
 function scan(){
  Object.entries(groups).forEach(([suffix,group])=>{
   const section=document.querySelector('[id$="__'+suffix+'"]');if(!section)return;
   const modern=Array.from(section.querySelectorAll('.buce-r40-campaigns__slide'));
   const slides=modern.length?modern:Array.from(section.querySelectorAll('.t4s-slide'));
   const elements=slides.length?slides:Array.from(section.querySelectorAll('.t4s-hero-image-item'));
   elements.forEach((el,i)=>{
    if(targets.has(el))return;
    const block=el.id?.replace(/^buce-campaign-/,'').replace(/^b_/,'')||'hero';const angle=group.blocks?.[block]||'principal';
    el.dataset.buceBannerId=group.campaign+':'+angle;el.dataset.buceBannerCampaign=group.campaign;el.dataset.buceBannerAngle=angle;el.dataset.buceBannerPosition=String(i+1);
    targets.set(el,{ratio:0,timer:null});observer?.observe(el);
    status.targets=targets.size;
   });
  });
 }
 document.addEventListener('click',event=>{
  const link=event.target.closest?.('a[href]'),el=link?.closest('[data-buce-banner-id]');
  if(!el||event.defaultPrevented||isQA())return;
  const p=props(el);
  if(allowed('analytics')&&publish('banner_click',p))status.clicks++;
  if(!allowed('analytics')||!allowed('marketing'))return;
  const r=read()||{first:p.banner_id,started:Date.now()};r.last=p.banner_id;r.clicked=Date.now();save(r);sync(r);
 },false);
 function consent(){
  if(isQA())return;
  if(!allowed('analytics')||!allowed('marketing')){let previous=memory;try{previous=previous||sessionStorage.getItem(key);sessionStorage.removeItem(key);}catch{}memory=null;if(previous||status.cartWrite==='saved')sync(null,true);}
  targets.forEach((v,el)=>inspect(el));
 }
 document.addEventListener('visitorConsentCollected',consent);
 document.addEventListener('visibilitychange',()=>targets.forEach((v,el)=>inspect(el)));
 document.addEventListener('shopify:section:load',scan);
 document.addEventListener('buce:ah-state',event=>{rewardToken=String(event.detail?.cart?.token||'');rewardCurrency=event.detail?.cart?.currency||'';});
 document.addEventListener('buce:v2-event',event=>{
  if(event.detail?.name!=='savings_level_confirmed'||isQA()||!allowed('analytics'))return;
  const p=event.detail.props||{},state=window.BuceAH?.state?.();
  if(!state?.confirmed||rewardCurrency!=='COP'||!rewardToken||!Number.isInteger(p.level)||p.level<2||p.level>6||p.level!==state.level||p.pairs!==state.pairs||!Number.isFinite(p.saving_cop)||p.saving_cop<=0||Math.round(p.saving_cop*100)!==state.actual)return;
  const levels=rewarded.get(rewardToken)||new Set();if(levels.has(p.level))return;
  const safe={level:p.level,pairs:p.pairs,saving_cop:p.saving_cop,currency:'COP',benefit:p.level===6?'free_pair':'fixed',theme_id:String(window.Shopify?.theme?.id||''),measurement_version:status.version};
  if(publish('savings_level_confirmed',safe,false)){levels.add(p.level);rewarded.set(rewardToken,levels);status.savings++;}
 });
 window.addEventListener('pageshow',()=>{scan();const r=read();if(r)sync(r);});
 if(window.MutationObserver)new MutationObserver(()=>targets.forEach((v,el)=>inspect(el))).observe(document.body,{subtree:true,attributes:true,attributeFilter:['class']});
 function privacy(){
  if(window.Shopify?.customerPrivacy){consent();const r=read();if(r)sync(r);return;}
  if(!privacyRequested&&window.Shopify?.loadFeatures){privacyRequested=true;window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error){consent();const r=read();if(r)sync(r);}});}
 }
 scan();privacy();
 window.BuceBannerMetrics={status,rescan:scan};
})();

